import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const RelatorioDinamicoList = props => <DefaultDataTable data={props} />;
